import { c as _c } from "react/compiler-runtime";
import { Clock, FileText, PenTool, Shield, X } from 'lucide-react';
import React from 'react';
interface ModalEscolhaFinalizacaoProps {
  isOpen: boolean;
  onClose: () => void;
  onPublicarDiretamente: () => void;
  onSolicitarAssinatura: () => void;
  nomeProcesso?: string;
}
const ModalEscolhaFinalizacao: React.FC<ModalEscolhaFinalizacaoProps> = t0 => {
  const $ = _c(28);
  const {
    isOpen,
    onClose,
    onPublicarDiretamente,
    onSolicitarAssinatura,
    nomeProcesso: t1
  } = t0;
  const nomeProcesso = t1 === undefined ? "Cumprimento de Senten\xE7a" : t1;
  if (!isOpen) {
    return null;
  }
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="text-xl font-semibold text-gray-900">Como deseja finalizar?</h2>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <X className="h-6 w-6" />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== onClose) {
    t4 = <div className="flex items-center justify-between border-b p-6">{t2}<button onClick={onClose} className="text-gray-400 transition-colors hover:text-gray-600">{t3}</button></div>;
    $[2] = onClose;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== nomeProcesso) {
    t5 = <p className="mb-6 text-gray-600">Escolha como deseja finalizar o <strong>{nomeProcesso}</strong>:</p>;
    $[4] = nomeProcesso;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex-shrink-0"><FileText className="h-6 w-6 text-blue-600 group-hover:text-blue-700" /></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h3 className="font-medium text-gray-900 group-hover:text-blue-900">Publicar Diretamente</h3>;
    t8 = <p className="mt-1 text-sm text-gray-600">O documento será protocolado imediatamente no sistema judicial</p>;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex items-start space-x-3">{t6}<div className="flex-1 text-left">{t7}{t8}<div className="mt-2 flex items-center text-xs text-green-600"><Clock className="mr-1 h-3 w-3" />Processamento imediato</div></div></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== onPublicarDiretamente) {
    t10 = <button onClick={onPublicarDiretamente} className="group w-full rounded-[8px] border-2 border-gray-200 p-4 transition-all hover:border-blue-500 hover:bg-blue-50">{t9}</button>;
    $[10] = onPublicarDiretamente;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex-shrink-0"><PenTool className="h-6 w-6 text-purple-600 group-hover:text-purple-700" /></div>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <h3 className="font-medium text-gray-900 group-hover:text-purple-900">Solicitar Assinatura Digital</h3>;
    t13 = <p className="mt-1 text-sm text-gray-600">Enviar para um advogado responsável assinar digitalmente antes do protocolo</p>;
    $[13] = t12;
    $[14] = t13;
  } else {
    t12 = $[13];
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="flex items-start space-x-3">{t11}<div className="flex-1 text-left">{t12}{t13}<div className="mt-2 flex items-center text-xs text-purple-600"><Shield className="mr-1 h-3 w-3" />Maior segurança jurídica</div></div></div>;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== onSolicitarAssinatura) {
    t15 = <button onClick={onSolicitarAssinatura} className="group w-full rounded-[8px] border-2 border-gray-200 p-4 transition-all hover:border-purple-500 hover:bg-purple-50">{t14}</button>;
    $[16] = onSolicitarAssinatura;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t10 || $[19] !== t15) {
    t16 = <div className="space-y-4">{t10}{t15}</div>;
    $[18] = t10;
    $[19] = t15;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== t16 || $[22] !== t5) {
    t17 = <div className="p-6">{t5}{t16}</div>;
    $[21] = t16;
    $[22] = t5;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="rounded-b-lg bg-gray-50 px-6 py-4"><p className="text-center text-xs text-gray-500">Você pode alterar esta configuração nas preferências do sistema</p></div>;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== t17 || $[26] !== t4) {
    t19 = <div className="bg-opacity-50 fixed inset-0 z-50 flex items-center justify-center bg-black"><div className="mx-4 w-full max-w-md rounded-lg bg-white shadow-xl">{t4}{t17}{t18}</div></div>;
    $[25] = t17;
    $[26] = t4;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  return t19;
};
ModalEscolhaFinalizacao;